import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { JwtAuthService } from "../../auth/services/jwt-auth.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TokenDataService } from "app/shared/services/token-data.service";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class UserRoleGuard implements CanActivate {
  constructor(private router: Router, private jwtAuth: JwtAuthService, 
    private snack: MatSnackBar, private tokenDataService: TokenDataService,
    private translate: TranslateService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    var user = this.jwtAuth.getUser();
    if (!route?.data?.authData) return true;
    if (
      user &&
      route.data && 
      this.tokenDataService.hasClaim({ operacije: route.data.authData.operacije })
    ) {
      return true;
    } else {
      this.snack.open(this.translate.instant("general.NotAccessPage"), this.translate.instant("general.ok"));
      // this.router.navigate([""]);
      return false;
    }
  }
}
